import { toast } from '@kalos/ui';
import { createFileRoute, redirect } from '@tanstack/react-router';

import { NewHiresDashboard } from '../modules/NewHire/main';
import { newHireDashboardCheck } from '../tools/permissionChecks';

export const Route = createFileRoute('/newHire')({
  component: RouteComponent,
  loader(ctx) {
    const permissionCheck = newHireDashboardCheck(ctx.context.authContext.user);
    if (!permissionCheck) {
      toast({
        title: 'Access Denied',
        description:
          'You do not have permission to access the New Hire Dashboard. Please contact your administrator if you believe this is an error.',
        variant: 'destructive',
      });
      throw redirect({ to: '/' });
    }
  },
  head() {
    return {
      meta: [{ title: 'New Hire Dashboard' }],
    };
  },
});

function RouteComponent() {
  return <NewHiresDashboard />;
}
